import React, { useCallback, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import clsx from "clsx";


let splitList = (str:string) => {
  return str.split("\n").map((name)=>name.trim());
}

let winners_list = [];


winners_list[1] = (splitList(`
mymy
goldengourd
Northuldra
ScrapperGal
Tigerbella
MadSparrow
Raven_Wildspirit
PunkRockUniverse
AngelKat
BALLROOMDANCER
Kanyaluv
CaptainBlueMaxx
Icyblue
bingobabe
Osmello
Tatiana_SilverHeart
PrincessAveri
Poorbe
Scarlett
wildsplashstone
Captain_Wesker
funfly
Zaphire
`));
winners_list[2] = (splitList(`
Sunshinesmiles
Lily_Hoshikawa
MadHare
Adventure_Rabbit
gumdrop
Auntie_Skybluepink
TacoCat
CuteStarPluto
elyssabeth
DaisyGlitterHeart
stephyrocks
carefullittlewolf
BERNARDO_S_ROCKS
Zanze
Kitten
Ormonddude
Iggy
MellowMoz
sleepyjack
`));
winners_list[3] = (splitList(`
Splash
Aprillo
TeddyExplorer
Pink
JDBud
Patticakes
Holly
CarsBoyJacob
SpaceAce
Pendric
Shana
Kirene
Squeak
PCJam
Hollymist
ooops
Miss_Sparklefeet
StrawberryRose
dazzlej
Abriko
Knityarny
LoveReading
Sassy_Wildspirit
`));
winners_list[4] = (splitList(`
Myshi
Mila
Chance_Braveheart
Pizzaguy
Teapotprincess
Bookcrazy
AnglerGirl
KimmiePie
FaeryDaze
iamabigdisfan
Star_Wildspirit
readingfreak
LilRockette
ChickenGirl
Its.Bella
Hopeful
TrickOrTreater
Arissia
peanutbutterchicken
`));
winners_list[5] = (splitList(`
CurlyShuffle
Dewella
HersheyGirl
Zakia
Turkeygirl
RetroRockette
acerocky
Akadia
LittleToni
Toadster
PrincessGirly
RyKnow
bluerail
Wild-Hearts
Giraffy
Nepeta
Callista
coffeecake
AlexanderHamlipup
Banu
ballerinalilly
`));



const data = [
  {
    title: "First Place",
    list: winners_list[1].map((name) => {return { title: name }}),
  },
  {
    title: "Second Place",
    list: winners_list[2].map((name) => {return { title: name }}),
  },
  {
    title: "Third Place",
    list: winners_list[3].map((name) => {return { title: name }}),
  },
  {
    title: "Fourth Place",
    list: winners_list[4].map((name) => {return { title: name }}),
  },
  {
    title: "Fifth Place",
    list: winners_list[5].map((name) => {return { title: name }}),
  },
];

export const ImageDisplayPanel = (props: any) => {
  const [image, setImage] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);

  const HandleItemClick = useCallback(
    (e) => {
      let title = e.target.dataset.title;
      setSelectedTitle(title);
      setImage(title);
    },
    [setSelectedTitle, setImage]
  );

  const src = `//www.virtualfamilykingdom.com/contests/halloween2025_contest/${image}.jpg`;

  return (
    <div className="display-base">
      <div className="image-container">
        {image ? (
          <LazyLoadImage
            alt={image}
            src={image ? src : null}
            height={400}
          />
        ) : (
          <div className="image-placeholder">
            Click A Position Below To View The Room Image!
          </div>
        )}
      </div>
      <div className="list-panel-container">
        {data.map(({ title, list }) => {
          return (
            <div className="list-panel" key={title}>
              <div className="list-panel__header">{title}</div>
              <div className="list-panel-content">
                {list.map(({ title }) => {
                  return (
                    <div
                      className={clsx(
                        "list-panel__item",
                        title === selectedTitle && "list-pane__item--selected"
                      )}
                      data-title={title}
                      key={title}
                      onClick={HandleItemClick}
                    >
                      {title}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
